import React from 'react';
import ShipmentStatusBadge from './ShipmentStatusBadge';

const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  fontSize: '12px',
  border: '1px solid var(--border)',
  borderRadius: '6px',
  backgroundColor: 'var(--card-bg)',
  color: 'var(--text)',
  outline: 'none'
};

const sectionStyle = {
  backgroundColor: 'var(--card-bg)',
  borderRadius: '8px',
  padding: '1rem',
  marginBottom: '1rem',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
};

const buttonStyle = {
  padding: '6px 12px',
  fontSize: '12px',
  cursor: 'pointer',
  fontWeight: '500',
  display: 'flex',
  alignItems: 'center',
  gap: '0.35rem'
};

const TrackingTab = ({ trackingNumber, setTrackingNumber, trackingResult, tracking, trackingError, onTrack }) => {
  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div style={sectionStyle}>
        <h6 style={{ margin: '0 0 1rem', fontSize: '14px', fontWeight: '600', color: 'var(--text-secondary)', textAlign: 'center' }}>
          Sledzenie przesylki
        </h6>

        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <input
            type="text"
            value={trackingNumber}
            onChange={(e) => setTrackingNumber(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onTrack()}
            placeholder="Wpisz numer sledzenia..."
            style={{ ...inputStyle, flex: 1 }}
          />
          <button
            onClick={onTrack}
            disabled={tracking}
            style={{
              ...buttonStyle,
              backgroundColor: tracking ? 'var(--text-muted)' : 'var(--primary)',
              color: '#fff' ,
              fontWeight: '600'
            }}
          >
            {tracking ? 'Sprawdzam...' : 'Sprawdz'}
          </button>
        </div>

        {trackingError && (
          <div style={{
            padding: '0.75rem',
            backgroundColor: 'var(--danger-light)',
            color: 'var(--danger)',
            borderRadius: '4px',
            marginTop: '1rem',
            textAlign: 'center'
          }}>
            {trackingError}
          </div>
        )}

        {trackingResult && (
          <div style={{
            marginTop: '1.5rem',
            padding: '1rem',
            backgroundColor: 'var(--bg)',
            borderRadius: '8px'
          }}>
            <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
              <ShipmentStatusBadge status={trackingResult.status} size="large" />
            </div>

            <div style={{ display: 'grid', gap: '0.5rem', fontSize: '12px' }}>
              <div><strong>Numer:</strong> {trackingResult.tracking_number}</div>
              {trackingResult.service && <div><strong>Usluga:</strong> {trackingResult.service}</div>}
              {trackingResult.custom_attributes?.target_point && (
                <div><strong>Paczkomat:</strong> {trackingResult.custom_attributes.target_point}</div>
              )}
            </div>

            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
              <a
                href={`https://inpost.pl/sledzenie-przesylek?number=${trackingResult.tracking_number}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...buttonStyle,
                  backgroundColor: 'var(--warning)',
                  color: 'var(--text)',
                  textDecoration: 'none',
                  display: 'inline-flex'
                }}
              >
                Otworz na stronie InPost
              </a>
            </div>
          </div>
        )}
      </div>

      <div style={{
        marginTop: '1rem',
        padding: '0.75rem',
        backgroundColor: 'var(--info-light)',
        borderRadius: '8px',
        border: '1px solid var(--info-light)',
        fontSize: '11px',
        color: 'var(--info)'
      }}>
        <strong>Wskazowka:</strong> Mozesz tez skopiowac numer sledzenia i sprawdzic status bezposrednio na{' '}
        <a href="https://inpost.pl/sledzenie-przesylek" target="_blank" rel="noopener noreferrer">
          stronie InPost
        </a>
      </div>
    </div>
  );
};

export default TrackingTab;
